module.exports = __webpack_public_path__ + "img/preferences-desktop-cryptography.754279f2.png";